import Repository from '@/libs/axios'

const statusSettingsResource = '/admin/settings'

export default {
  updateOrderStatuses(id, payload) {
    return Repository.put(`${statusSettingsResource}/order-status/${id}`, payload)
  },
  updateFinanceStatuses(payload) {
    return Repository.put(`${statusSettingsResource}/finance-status`, payload)
  },
  setFinanceStatusActive(key, isActive) {
    return Repository.put(`/admin/finance/status/${key}/set-active`, { is_active: isActive })
  },
  getStatusSettings() {
    return Repository.get(`${statusSettingsResource}/status`)
  },
  updateStatusSettings(payload) {
    return Repository.put(`${statusSettingsResource}/status`, payload)
  },
}
